var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-base-layout',[_c('v-main',[_c('FloatingSupport'),_vm._v(" "),_c('nuxt')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }